/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'warn': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g clip-path="url(#clip0_1387_28785)"><path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M7.14 1.493a1 1 0 011.723 0l6.999 11.886A1 1 0 0115 14.886H1.002A1 1 0 01.14 13.38l7-11.886zM9.1 13c0 .552-.492 1-1.1 1-.608 0-1.1-.448-1.1-1s.492-1 1.1-1c.608 0 1.1.448 1.1 1zM8 4a1 1 0 00-1 1v5a1 1 0 102 0V5a1 1 0 00-1-1z" _fill="#fff"/></g><defs><clipPath id="clip0_1387_28785"><path pid="1" _fill="#fff" d="M0 0h16v16H0z"/></clipPath></defs>'
  }
})
